const {
  REACT_APP_VERSION,
} = process.env;

export function printVersion() {
  // eslint-disable-next-line
  console.log(`Version: ${REACT_APP_VERSION}, branch: ${window.NextivaEnv}`);
}
